import { render } from "./MarketReports.vue?vue&type=template&id=0064a2cb&scoped=true"
import script from "./MarketReports.vue?vue&type=script&lang=js"
export * from "./MarketReports.vue?vue&type=script&lang=js"

import "./MarketReports.vue?vue&type=style&index=0&id=0064a2cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0064a2cb"]])

export default __exports__